import salesReducer from "./salesReducer"
export default salesReducer